module.exports = __webpack_public_path__ + "img/robust.49acc461.png";